module.exports = __webpack_public_path__ + "static/media/tu-dublin.7fa799c2.png";